<template>
  <div>
    <div>
      <span>Gene:</span>
      <el-select v-model="formData.Gene"
                 clearable
                 filterable
                 size="mini"
                 :filter-method="filterMethod"
                 v-el-select-loadmore="loadMore"
                 @visible-change="visibleChange"
                 placeholder="please select">
        <el-option
            v-for="item in gene_list_options.slice(0, rangeNumber)"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
      <el-button size="mini" type="info" round style="margin-left: 10px" @click="changeGene">submit</el-button>
      <el-button size="mini" type="info" round @click="reset_selected_gene">fresh</el-button>
    </div>
    <div :id="markerPicId" style="width: 400px; height: 400px"/>
  </div>
</template>

<script>
import {_debounce} from "@/util/debounce";
import Vue from "vue";
import * as echarts from "echarts/core";

export default {
  name: "MarkerCard",
  data() {
    return {
      markerPicId: '',
      formData: {
        datasetID: '',
        Array: '',
        Gene: '',
      },
      gene_list: [],
      gene_list_options: [],
      SVG: {
        path: '',
        data: []
      },
      position: [],
      rangeNumber: 100,
    }
  },
  props: {
    cardID: String,
  },
  mounted() {
    this.markerPicId = 'marker_pic' + this.cardID
    // this.info = this.$attrs.data.info
    // console.log(this.$attrs)
    // console.log(this.$attrs.data.info_type)
    this.formData.datasetID = this.$attrs.data.datasetID
    this.formData.Array = this.$attrs.data.array
    this.position = this.$attrs.data.position
    this.gene_list = this.$attrs.data.genes
    console.log(this.gene_list)
    this.$nextTick(function () {
      this.initMarkerEcharts()
    })
  },
  directives: {
    'el-select-loadmore': (el, binding) => {
      // console.log(el)
      // console.log(binding)
      // 获取element-ui定义好的scroll盒子
      const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
      if (SELECTWRAP_DOM) {
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          /**
           * scrollHeight 获取元素内容高度(只读)
           * scrollTop 获取或者设置元素的偏移值,
           *  常用于:计算滚动条的位置, 当一个元素的容器没有产生垂直方向的滚动条, 那它的scrollTop的值默认为0.
           * clientHeight 读取元素的可见高度(只读)
           * 如果元素滚动到底, 下面等式返回true, 没有则返回false:
           * ele.scrollHeight - ele.scrollTop === ele.clientHeight;
           */
          const condition = this.scrollHeight - this.scrollTop - 10 <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    },
  },
  methods: {
    filterMethod: _debounce(function (filterVal) {
      if (filterVal) {
        this.gene_list_options = this.gene_list.filter((item) => {
          return item.includes(filterVal)
        });
      } else {
        this.gene_list_options = this.gene_list;
      }
    }, 500),
    loadMore() {
      // n是默认初始展示的条数会在渲染的时候就可以获取,具体可以打log查看
      // elementui下拉超过7条才会出滚动条,如果初始不出滚动条无法触发loadMore方法
      this.rangeNumber += 20
      // return () => (this.rangeNumber += 100); // 每次滚动到底部可以新增条数  可自定义
    },
    // 下拉框出现时，调用过滤方法
    visibleChange(flag) {
      if (flag) {
        this.filterMethod()
      }
    },

    initMarkerEcharts(){
      const chartDom = document.getElementById(this.markerPicId);
      const myChart = echarts.init(chartDom);
      let option;
      const schema = [
        { name: 'x', index: 0, text: 'x' },
        { name: 'y', index: 1, text: 'y' },
        { name: 'gene', index: 2, text: 'gene' },
        { name: 'expression', index: 3, text: 'expression' },
      ];
      option = {
        color: ['#ff0000'],
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15,  //值越大分辨率越高,下载的图片越清晰
              name: "marker.png",
            },
          },
        },
        // grid: {
        //   right: '15%',
        // },
        visualMap: [
          {
            right: 0,
            bottom: '40%',
            dimension: 3,
            type: 'continuous',
            calculable:true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime:true,                          //拖拽时，是否实时更新
            precision:0,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 10,
            itemHeight: 120,
            align:"auto",
            text: ['expression'],
            textGap: 20,
            inRange: {
              color: ['#d9d9d9','blue']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                color: ['#d9d9d9', 'blue']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + schema[2].text + '：' + value[2]
                + '</div>'
                + schema[0].text + '：' + value[0] + '<br>'
                + schema[1].text + '：' + value[1] + '<br>'
                + schema[3].text + '：' + value[3] + '<br>';
          }
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        series: [
          {
            symbolSize: 3,
            data: [
              [1, 1,'test',20],
            ],
            type: 'scatter'
          }
        ]
      };
      option && myChart.setOption(option);
    },
    changeGene() {
      let _this = this
      _this.SVG.data = []
      if (_this.formData.Gene === ''){
        Vue.prototype.$message.warning("Please choose gene first")
        return
      }
      _this.$axios.get(
          'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/marker/gene/echarts/'
          + _this.formData.datasetID + '/' + _this.formData.Array + '/' + _this.formData.Gene)
          .then(function (response) {
            _this.addZeroPosition(_this.formData.Gene, response.data.data)
            if (response.status === 200) {
              Vue.prototype.$message.success(_this.formData.Gene + " success!")
              _this.reload_echarts_data()
            }
          }).catch(function () {
            Vue.prototype.$message.error(_this.formData.Gene + " Something is wrong...")
          })
    },
    reset_selected_gene() {
      let _this = this
      _this.formData.Gene = []
      _this.SVG.data = []
      _this.reload_echarts_data()
    },
    reload_echarts_data(){
      let temp_Gene = this.formData.Gene
      let _this = this
      const myChart = echarts.getInstanceByDom(document.getElementById(this.markerPicId));
      let option;
      option = {
        title: {
          text: temp_Gene,
        },
        visualMap: [
          {
            min: _this.getMinV(_this.SVG.data, 3),
            max: _this.getMaxV(_this.SVG.data, 3),
          }
        ],
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        series: [
          {
            symbolSize: 3,
            data: _this.SVG.data,
            type: 'scatter'
          }
        ]
      };
      myChart.setOption(option);
    },
    addZeroPosition(name, Array){
      let _this = this
      let temp = []
      for (let i =0; i< _this.position.length; i++){
        temp.push([_this.position[i].x,_this.position[i].y,name,0])
      }
      for (let i =0; i< Array.length; i++){
        temp.push(Array[i])
      }
      _this.SVG.data = temp
    },
    getMaxV(distributionInfo, dimension) {
      let max = 0
      for (let i=0;i<distributionInfo.length;i++) {
        if (max < Number(distributionInfo[i][dimension])){
          max = Number(distributionInfo[i][dimension])
        }
      }
      return max
    },
    getMinV(distributionInfo, dimension) {
      let min = 99999
      for (let i=0;i<distributionInfo.length;i++) {
        if (min > Number(distributionInfo[i][dimension])){
          min = Number(distributionInfo[i][dimension])
        }
      }
      return min
    },
  }
}
</script>

<style scoped>

</style>
